import {Injectable} from '@angular/core';
import {NavController} from '@ionic/angular';
import {UtilsService} from '../utils/utils.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private _navCtrl: NavController,
    private _router: Router,
    private _utilsService: UtilsService) {
  }

  back() {
    this._navCtrl.back();
  }

  goToHome(localeId: string) {
    this._router.navigate(['/', localeId]);
  }

  goToProfile() {
    this._router.navigate(['/profilo']);
  }

  goToPersonalInfo() {
    this._router.navigate(['/profilo', 'informazioni-personali']);
  }

  goToLogin() {
    this._router.navigate(['/accedi']);
  }

  goToLoginBoccio() {
    this._router.navigate(['/boccio/accedi']);
  }

  goToLoginSporting() {
    this._router.navigate(['/sporting/accedi']);
  }

  goToHomeLocale(idLocale: string) {
    this._router.navigate(['/', idLocale]);
  }

  goToMenuLocale(idLocale: string) {
    this._router.navigate(['/', idLocale, 'menu']);
  }

  goToTermsConditions() {
    this._router.navigate(['/termini-e-condizioni']);
  }

  goToLocation(idLocale: string) {
    this._router.navigate(['/', idLocale, 'posizione']);
  }

  goToPrivateEvents(idLocale: string) {
    this._router.navigate(['/', idLocale, 'eventi-privati']);
  }

  goToPublicEvents(idLocale: string) {
    this._router.navigate(['/', idLocale, 'aperti-pubblico']);
  }

  goToCalendar(idLocale: string) {
    this._router.navigate(['/', idLocale, 'aperti-pubblico', 'calendario']);
  }

  goToContacts(idLocale: string) {
    this._router.navigate(['/', idLocale, 'contatti']);
  }

  goToLoginWithRedirect(timestamp: string) {
    this._router.navigate(['/', 'accedi'], {queryParams: {t: timestamp}});
  }

  goToLoginWithPreBookingRedirect() {
    this._router.navigate(['/', 'accedi'], {queryParams: {'pre-booking': true}});
  }

  goToAccredito(timestamp: string, localeId: string) {
    this._router.navigate(['/', localeId, 'accredito', timestamp]);
  }

  goToFidelity(orderId: string, localeId: string) {
    this._router.navigate(['/', localeId, 'fidelity', orderId]);
  }

  goToPremium(idLocale: string) {
    this._router.navigate(['/', idLocale, 'aperti-pubblico'], {fragment: 'premium'});
  }

  goToStandard(idLocale: string) {
    this._router.navigate(['/', idLocale, 'aperti-pubblico'], {fragment: 'standard'});
  }

  goToApericena(idLocale: string) {
    this._router.navigate(['/', idLocale, 'aperti-pubblico'], {fragment: 'apericena'});
  }

  goToCocktails(idLocale: string) {
    this._router.navigate([`/${idLocale}/cocktails`]);
  }

  goToMenuTortunaki(idLocale: string) {
    this._router.navigate([`/${idLocale}/menu-tortunaki`]);
  }

  goToBottlesList(idLocale: string) {
    this._router.navigate([`/${idLocale}/bottiglie`]);
  }

  goToLoginPremium(idLocale: string) {
    this._router.navigate([`/${idLocale}/vip`]);
  }

  goToBookings(idLocale: string) {
    this._router.navigate([`/${idLocale}/bookings`]);
  }

  goToBasket(idLocale: string) {
    this._router.navigate([`/${idLocale}/bookings/basket`]);
  }

  goToPrebooking(idLocale: string) {
    this._router.navigate([`/${idLocale}/procedura-di-booking`]);
  }

  goToPrebookingLocals() {
    this._router.navigate([`/profilo/prenotazioni/locali`]);
  }

  goToPrebookingConfirmation(idLocale: string) {
    this._router.navigate([`/${idLocale}/procedura-di-booking/conferma`]);
  }

  goToBoccioBasket() {
    this._router.navigate([`/boccio/basket`]);
  }

  goToSportingBasket() {
    this._router.navigate([`/sporting/basket`]);
  }

  goToBoccioNoP() {
    this._router.navigate([`/boccio/basket/table-selection/number-of-people-selection`]);
  }


  goToSportingNoP() {
    this._router.navigate([`/sporting/basket/table-selection/number-of-people-selection`]);
  }

  goToBoccioBasketConfirmation() {
    this._router.navigate([`/boccio/basket/table-selection/confirmation`]);
  }

  goToSportingBasketConfirmation() {
    this._router.navigate([`/sporting/basket/table-selection/confirmation`]);
  }

  goToBoccioBasketTables() {
    this._router.navigate([`/boccio/basket/table-selection`]);
  }

  goToSportingBasketTables() {
    this._router.navigate([`/sporting/basket/table-selection`]);
  }

  goToBoccio() {
    this._router.navigate([`/boccio`]);
  }
  goToSporting() {
    this._router.navigate([`/sporting`]);
  }

  goToBoccioOrderSent() {
    this._router.navigate([`/boccio/basket/table-selection/confirmation/end`]);
  }

  goToSportingOrderSent() {
    this._router.navigate([`/sporting/basket/table-selection/confirmation/end`]);
  }

}
